<fieldset>
  <div class="option">
    <label i18n="@@choose-meal-plan-people-adult" for="adult-quantity">Adult</label>
    <product-quantity-selector
      id="adult-quantity"
      unit="none"
      [disableKeyboardInput]="true"
      [quantityResponse]="{ increment: 1, value: adultValue }"
      (incrementEmitter)="handleIncrement($event, 'adult')"
      (decrementEmitter)="handleDecrement($event, 'adult')"
    ></product-quantity-selector>
  </div>

  <div class="option">
    <label i18n="@@choose-meal-plan-people-child" for="child-quantity">Child</label>
    <product-quantity-selector
      id="child-quantity"
      unit="none"
      [disableKeyboardInput]="true"
      [quantityResponse]="{ increment: 1, value: childValue }"
      (incrementEmitter)="handleIncrement($event, 'child')"
      (decrementEmitter)="handleDecrement($event, 'child')"
    ></product-quantity-selector>
  </div>
</fieldset>